import { getFirstScreenOfNextScreenGroup } from '@src/containers/QuizContainer/screenHelpers';
import { QuizMappingType, defaultScreenMap } from '@src/containers/QuizContainer/screenMapping';
import { ScreenGroups, Screens } from '@src/containers/QuizContainer/types';

export const updateScreenMap = (screenGroupOrder: ScreenGroups[]) =>
	Object.keys(defaultScreenMap).reduce((newMap, screen) => {
		newMap[screen] = defaultScreenMap[screen];

		if (screen !== Screens.LOADING) {
			const defaultNextScreen = defaultScreenMap[screen].nextScreen.default;
			const screenGroupOfDefaultNextScreen = defaultScreenMap[defaultNextScreen].screenGroup;

			if (defaultScreenMap[screen].screenGroup !== screenGroupOfDefaultNextScreen) {
				const firstScreenOfNextScreenGroup = getFirstScreenOfNextScreenGroup(
					screenGroupOrder,
					screen
				);

				if (firstScreenOfNextScreenGroup === undefined) {
					newMap[screen].nextScreen.default = Screens.LOADING;
				} else {
					newMap[screen].nextScreen.default = firstScreenOfNextScreenGroup;
				}
			}
		}

		return newMap;
	}, {} as QuizMappingType);
